import { Injectable } from '@angular/core';
import { environment } from 'src/app/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  BaseLookup,
  CarrierLiteResponse,
  NamedResponse,
  SharedBrandsResponse,
  SharedCarriersResponse,
  SharedProductCategoriesResponse,
  SharedProductDepartmentsResponse,
  SharedSuppliersResponse,
  SharedUnitsResponse,
} from '../models/shared.model';
import { WarehouseCompResponse } from '../models/warehouseModel';

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  imsBaseUrl: string = environment.imsApiBaseUrl;
  listerBaseUrl: string = environment.listerApiBaseUrl;
  companyBaseUrl: string = environment.companyApiBaseUrl;
  constructor(private http: HttpClient) {}
  //shared endpoints
  getSharedDepartments(
    companyId: number
  ): Observable<SharedProductDepartmentsResponse[]> {
    const url = `${this.listerBaseUrl}/ProductDepartments?CompanyId=${companyId}`;
    return this.http.get<SharedProductDepartmentsResponse[]>(url);
  }
  getSharedSuppliers(companyId: number): Observable<SharedSuppliersResponse[]> {
    const url = `${this.listerBaseUrl}/Suppliers?CompanyId=${companyId}`;
    return this.http.get<SharedSuppliersResponse[]>(url);
  }
  getSharedUnits(companyId: number): Observable<SharedUnitsResponse[]> {
    const url = `${this.imsBaseUrl}/Units?CompanyId=${companyId}`;
    return this.http.get<SharedUnitsResponse[]>(url);
  }
  getSharedCategories(
    companyId: number,
    departmentId: number | null
  ): Observable<SharedProductCategoriesResponse[]> {
    const url = `${this.listerBaseUrl}/ProductCategories?CompanyId=${companyId}&DepartmentId=${departmentId}`;
    return this.http.get<SharedProductCategoriesResponse[]>(url);
  }
  getSharedBrands(companyId: number): Observable<SharedBrandsResponse[]> {
    const url = `${this.listerBaseUrl}/Brands?CompanyId=${companyId}`;
    return this.http.get<SharedBrandsResponse[]>(url);
  }
  getSharedCarriers(companyId: number): Observable<SharedCarriersResponse[]> {
    const url = `${this.imsBaseUrl}/Carriers?CompanyId=${companyId}`;
    return this.http.get<SharedCarriersResponse[]>(url);
  }

  // Method to get all shared lookups
  getLookups(): Observable<BaseLookup[]> {
    const url = `${this.listerBaseUrl}/StaticLookUps`;
    return this.http.get<BaseLookup[]>(url);
  }

  // Method to get warehouse locations
  getWarehouseLocations(
    companyId: number,
    warehouseId?: number,
    onlyProductionStation?: boolean
  ) {
    let url = `${this.imsBaseUrl}/WarehouseLocations/Lite`;
    const params: string[] = [];

    if (companyId !== undefined) {
      params.push(`CompanyId=${companyId}`);
    }
    if (warehouseId !== undefined) {
      params.push(`WarehouseId=${warehouseId}`);
    }
    if (onlyProductionStation !== undefined) {
      params.push(`OnlyProductionStation=${onlyProductionStation}`);
    }
    if (params.length > 0) {
      url += '?' + params.join('&');
    }
    return this.http.get<NamedResponse[]>(url);
  }
  //
  setDefaultWarehouse(userId: number, warehouseId: number, isDefault: boolean) {
    const url = `${this.companyBaseUrl}/Users/${userId}/Warehouses/${warehouseId}/Default`;
    return this.http.put(url, { isDefault: isDefault });
  }

  getWarehouses(
    companyId: number | undefined
  ): Observable<WarehouseCompResponse[]> {
    const url = `${this.imsBaseUrl}/Warehouses?CompanyId=${companyId}`;
    return this.http.get<WarehouseCompResponse[]>(url);
  }
  //shipment-box endpoints
  getShipmentBoxes(companyId: number): Observable<NamedResponse[]> {
    const url = `${this.imsBaseUrl}/ShipmentBoxes/Lite?CompanyId=${companyId}`;
    return this.http.get<NamedResponse[]>(url);
  }
  // Carrier Setvive
  getCarriers(companyId: number): Observable<SharedCarriersResponse[]> {
    const url = `${this.imsBaseUrl}/Carriers?CompanyId=${companyId}`;
    return this.http.get<SharedCarriersResponse[]>(url);
  }
  getCarriersLite(companyId: number): Observable<CarrierLiteResponse[]> {
    const url = `${this.imsBaseUrl}/Carriers/Lite?CompanyId=${companyId}`;
    return this.http.get<CarrierLiteResponse[]>(url);
  }
}
